<template>
  <section>
    <div class="article-list">
      <div class="article" v-for="(article , index) in articleData" v-bind:key="index">
        <a :href="'/articles/' + article.title.toLowerCase().replace(/ /g , '_').replace(/[^a-zA-Z0-9-_]/g, '')"></a>
        <div v-if="article.img !== ''" class="card-image" :style="'background-image: url(' + article.img + ');'"></div>
        <svg v-if="article.img === ''" class="card-image" viewBox="0 0 620 308" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect fill="#F4F4F4"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M357.73 116.943C360.233 114.44 360.233 110.381 357.73 107.878C355.226 105.374 351.168 105.374 348.664 107.878L310.308 146.234L282.784 120.545C280.918 118.803 278.197 118.334 275.855 119.352C273.514 120.369 272 122.678 272 125.231V185.06C272 188.601 274.87 191.471 278.41 191.471C281.951 191.471 284.821 188.601 284.821 185.06V139.982L306.088 159.832C308.613 162.189 312.552 162.121 314.995 159.678L357.73 116.943ZM348.924 163.693C348.924 160.152 346.054 157.282 342.513 157.282C338.973 157.282 336.103 160.152 336.103 163.693V185.06C336.103 188.601 338.973 191.471 342.513 191.471C346.054 191.471 348.924 188.601 348.924 185.06L348.924 163.693Z" fill="#D0D0D0"/>
        </svg>
        <div class="article-body">
          <h3>{{ article.title }}</h3>
          <p>{{ article.preview.slice(0 , 140) }}...</p>
          <button>Read More</button>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
export default {
  name: 'list',
  props: ['articleData']
}
</script>

<style lang="less" scoped>
.article-list {
  text-align: left;
  margin: 35px 0 25px 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  @media(max-width: 868px) {
    flex-direction: column;
    .article {
      margin: 0 0 45px 0;
    }
  }
  .article {
    flex: 0 0 30%;
    position: relative;
    margin: 0 0 4rem 0;
    border-radius: 4px;
    border: 1px solid #d4d4d4;
    box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .article-body {
      min-height: 200px;
      padding: 1.5rem;
      display: flex;
      flex-direction: column;
      button {
        margin-top: auto;
      }
    }
    a {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      bottom: 0;
      left: 0;
    }
  }
  .card-image {
    height: 200px;
    width: 100%;
    background-size: cover;
    background-position: center;
    transition: .2s all;
    background-color: #F4F4F4;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  .header {
    display: flex;
    @media(max-width: 868px) {
      flex-direction: column;
      .tag-list {
        margin-top: 10px !important;
      }
    }
  }
  .tag-list {
    display: inline;
    span {
      margin: 0 10px 0 0;
      padding: 5px 10px 5px 10px;
      background: rgba(121, 191, 255, 0.27);
      color: #104475;
      font-size: 12px;
      font-weight: 800;
      border-radius: 4px;
    }
  }
}
h3 {
  font-size: 1rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
}
p {
  text-align: left;
  font-size: 1rem;
  line-height: 2rem;
  font-weight: 400;
  color: #2c3e50e0;
  margin: 0 0 0 0;
}
h4 {
  margin: 0 15px 0 0;
}
button {
  padding: .75rem 20px;
  color: #FFF;
  background: #104475;
  font-weight: 700;
  font-size: 12px;
  border: none;
  border-radius: 4px;
}
</style>
